import { DataBean } from "../DataBean";

export class EmployeeContractType extends DataBean {



    public async getEmployeeContractTypeCatalog(args:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getEmployeeContractTypeCatalog_Number", [args]);
    }
     public async deleteEmployeeContractType(idEmployeeContractType:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteEmployeeContractType_Number", [idEmployeeContractType]);
    }
     public async updateEmployeeContractType(bean:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.admin.EmployeeContractType_updateEmployeeContractType_com.quickdataerp.bean.admin.EmployeeContractType", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.admin.EmployeeContractType"
            }
        ]);
    }
}